module.exports = __webpack_public_path__ + "img/qrcode_app_syncmanager.e8438f04.png";